import TextRoot, { Props } from './Text'

export default function Text(props: Props) {
  return <TextRoot {...props} />
}

export type { Props } from './Text'
